import { api } from '../config/api';

export interface StockSummary {
  in_storage: number;
  picked: number;
  staged: number;
  loaded: number;
  aging: number;
}

export interface PalletRow {
  id: number;
  sscc: string;
  status: string;
  job_number: string | null;
  customer_code: string | null;
  customer_name: string | null;
  product_description: string | null;
  stock_code: string | null;
  quantity: number | null;
  pallet_number: number | null;
  location_code: string | null;
  age_days: number;
  created_at: string;
}

export interface StockDashboardData {
  summary: StockSummary;
  pallets: PalletRow[];
}

export interface DespatchSummary {
  picks_outstanding: number;
  pallets_staged: number;
  pallets_loaded: number;
}

export interface DeliveryCard {
  id: number | null;
  customer_code: string;
  customer_name: string | null;
  license_plate: string | null;
  expected_pallets: number;
  loaded_pallets: number;
  status: 'active' | 'completed' | 'ready';
  started_at: string | null;
  completed_at: string | null;
}

export interface DespatchDashboardData {
  summary: DespatchSummary;
  deliveries: DeliveryCard[];
}

export interface LatestImport {
  imported_at: string;
  filename: string;
  records_imported: number;
}

export const getStockDashboard = async (params?: {
  search?: string;
  status?: string;
  age_threshold?: number;
}): Promise<StockDashboardData> => {
  const response = await api.get('/wms/dashboard/stock', { params });
  return response.data.data;
};

export const getDespatchDashboard = async (): Promise<DespatchDashboardData> => {
  const response = await api.get('/wms/dashboard/despatch');
  return response.data.data;
};

export const getLatestImport = async (): Promise<LatestImport | null> => {
  try {
    const response = await api.get('/wms/imports/latest');
    return response.data.data || null;
  } catch {
    return null;
  }
};
